<template>
  <div class="choose_date lg:hidden fixed z-20 bottom-0 left-0 right-0 bg-white p-4 pt-0">
    <CalculatorActions :lot-id="lotId" />
  </div>
</template>

<script setup>
import CalculatorActions from '~/components/lots/show/calculator_actions.vue'

defineProps({
  lotId: {
    type: [String, Number],
    required: true,
  },
})
</script>

<style lang="sass" scoped>
  .choose_date
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15)
</style>
